//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import MyBasePage from "../../components/MyBasePage";
import { copy } from "@/common/utils";
export default {
  name: "Business",
  components: {
    MyBasePage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      telegram: (state) => state.FrontConfigList.telegram,
    }),
  },
  methods: {
    handleService() {
      window.open("/chatlink.html", "_blank");
    },
    handleTelegram() {
      window.open(this.telegram, "_blank");
    },
    handleCopy($id) {
      const ele = document.getElementById($id);
      if (copy(ele))
        this.$vux.toast.show({
          text: this.$t("others.copySuceess"),
          type: "success",
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Business/index.vue